import { Product, UnsavedProduct, ProductInterface, ProductWithImage } from '@/types/product';
import { ProductResponseMulti, ProductResponseSingle } from '@/types/responses';
import HTTPService from './HTTPService';
import LogService from './LogService';
import Axios from 'axios';

class ProductsService {

  public fetchAllProducts(): Promise<Product[]> {
    return new Promise((resolve, reject) => {
      Axios.get('/products')
        .then((response: ProductResponseMulti) => resolve(Product.fromResponseMulti(response)))
        .catch((error) => {
          LogService.error('Error when retrieving products from server.', error);
          reject(error);
        });
    });
  }

  public createProduct(product: UnsavedProduct): Promise<Product> {
    return new Promise((resolve, reject) => {
      const postData = HTTPService.formData({
        name: product.name,
        description: product.description,
        tags: product.tags,
        is_available: product.is_available,
        image: product.image,
      });

      const settings = {
        headers: { 'Content-Type': 'multipart/form-data' },
      };

      Axios.post('/products', postData, settings)
        .then((response: ProductResponseSingle) => resolve(Product.fromResponseSingle(response)))
        .catch((error) => {
          LogService.error('Error when saving product to backend.', error.response.data);
          reject(error);
        });
    });
  }

  public updateProduct(product: ProductWithImage): Promise<Product> {
    return new Promise((resolve, reject) => {
      const postData = HTTPService.formData({
        name: product.name,
        description: product.description,
        tags: product.tags,
        is_available: product.is_available,
        image: product.image,
        _method: 'PATCH',
      });

      const settings = {
        headers: { 'Content-Type': 'multipart/form-data' },
      };

      Axios.post(`/products/${product.id}`, postData, settings)
        .then((response) => resolve(Product.fromResponseSingle(response)))
        .catch((error) => {
          LogService.error('Error when updating product in backend.', error.response.data);
          reject(error);
        });
    });
  }

  public deleteProduct(product: ProductInterface): Promise<ProductInterface> {
    return new Promise((resolve, reject) => {
      Axios.post(`/products/${product.id}`, HTTPService.deleteRequest())
        .then((response) => {
          if (response.data.successful) {
            resolve(product);
          } else {
            reject(response.data);
          }
        }).catch(reject);
    });
  }

}

export default new ProductsService();
